import { ApolloClient, InMemoryCache } from '@apollo/client'
import { loadErrorMessages, loadDevMessages } from '@apollo/client/dev'
import Cookies from 'js-cookie'

if (process.env.NODE_ENV !== 'production') {
  loadDevMessages()
  loadErrorMessages()
}

export default new ApolloClient({
  uri: '/frontier/graphql/',
  cache: new InMemoryCache(),
  headers: {
    fssessionid: Cookies.get('fssessionid'),
  },
})
